import { BaseQueryApi } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";

export const queryHandler = <
  T extends BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>
>(
  baseQuery: T
): T =>
  (async (args: FetchArgs, api: BaseQueryApi, extraOptions: any) => {
    const result = await baseQuery(args, api, extraOptions);
    // if (result?.error) {
    //   const error = result.error.data as FetchResponse.Error;

    //   if (error.application_error_code === "PAYMENT_PENDING") {
    //     return;
    //   }

    //   if (error.statusCode === 401) {
    //     api.dispatch(logout());
    //     return;
    //   }

    //   const message = error.message || "error";

    //   const feedback =
    //     FETCH_ERROR_FEEDBACK[message] ?? FETCH_ERROR_FEEDBACK["error"];

    //   toast.error(feedback);
    // }
    return result;
  }) as unknown as T;
